<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    v-model="selected"
    :menu-props="{ offsetY: true, overflowY: true, closeOnContentClick: true }"
    :items="items"
  >
    <template slot="item" slot-scope="{ item, index }">
      {{ $t(`education.${item.toLowerCase()}`) }}
    </template>
    <template slot="selection" slot-scope="{ item, index }">
      {{ $t(`education.${item.toLowerCase()}`) }}
    </template>
  </v-select>
</template>

<script>
  import graduationLevels from "./graduationLevels";

  export default {
    inheritAttrs: false,
    name: "GraduationLevelPicker",
    props: {
      value: [String, Array]
    },
    data: () => ({
      items: graduationLevels,
      selected: null
    }),
    watch: {
      value: {
        handler(v) {
          this.selected = v;
        },
        immediate: true
      }
    }
  };
</script>

<style scoped></style>
